import { TextColorCard } from "shared/components/cards/TextColorCard";
import { IconDispatcher } from "shared/Icons";
import styled from "styled-components";

interface MenuItemSelectorProps {
	id?: string;
	title?: string;
	description?: string;
	placeholder?: string;
	cardProps?: any;
	renderLabel?: any;
	icon?: string;
	classNames?: string;
}

export const MenuItemSelector = ({ title, description, renderLabel, placeholder, cardProps, icon, classNames }: MenuItemSelectorProps): JSX.Element => {
	return (
		<Container className={classNames}>
			<Header>
				<TitleContainer>
					<LogoContainer>
						<Logo>{IconDispatcher(icon)}</Logo>
					</LogoContainer>
					<Title>{title || placeholder}</Title>
				</TitleContainer>
				<InsightTypeContainer>
					{renderLabel && renderLabel()}
					{cardProps && <TextColorCard {...cardProps} />}
				</InsightTypeContainer>
			</Header>
			{description && <Description>{description}</Description>}
		</Container>
	);
};

const Container = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
`;

const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
`;

const TitleContainer = styled.div`
	position: relative;
`;

const Title = styled.div`
	color: #262626;
	font-size: 14px;
	font-weight: 600;
	text-indent: 2rem;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
	overflow: hidden;
`;

const LogoContainer = styled.div`
	position: absolute;
	width: 24px !important;
	height: 24px !important;

	svg {
		width: 16px;
		height: 16px;
	}
`;

const Logo = styled.div`
	width: 100%;
	height: 100%;
	border: 1px solid #262626;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #fff;
`;

const Description = styled.div`
	width: 100%;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
	color: #262626;
	font-style: normal;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	margin-top: 4px;
`;

const InsightTypeContainer = styled.div`
	display: flex;
	align-self: flex-start;
`;
